const zh_CN = {
  restartInterviewButton: "重新开始",
  restartInterviewConfirmTitle: "重新开始访谈？",
  restartInterviewConfirmDescription: "将创建一次新的访谈，不会接着当前进度进行。已有记录会保留。",
  restartInterviewCancel: "取消",
  restartInterviewFailed: "重新开始访谈失败，请稍后重试",
  restartInterviewLimitReached: "访谈名额已满，无法重新开始。",
  restartInterviewClosed: "访谈已关闭，无法重新开始。",
  restartInterviewCutoff: "访谈已过截止时间，无法重新开始。",
  interviewLoading: "正在加载访谈…",
  interviewLinkInvalid: "访谈链接无效",
  interviewLoadFailed: "加载访谈失败，请稍后重试",
  interviewRetry: "重试",
  saveInfoFailed: '保存信息失败，请重试',
  loadLatestInterviewFailed: '无法加载最新访谈记录，请稍后重试',
  interviewProgressSaved: '访谈进度不会丢失',
  previousStimulus: '上一个概念',
  nextStimulus: '下一个概念',
  expandStimulus: '放大概念',
  closeStimulusPreview: '关闭概念预览',
  stimulusPreview: '概念预览',
  imageTooLarge: '图片大小不能超过 10 MB',
  imageFormatJpegPngOnly: '只支持 PNG、JPEG 和 JPG 格式的图片',
  imageFilesOnly: '只支持上传图片文件',
  imageUploadFailed: '上传图片失败，请重试',
  finalUploadFailed: '上传文件失败，请重试',
  Welcome: '欢迎来到',
  StartInterview: '开始访谈',
  Submit: '提交',
  Stoprecording: '停止回复',
  Aiinterviewer: '访谈人',
  AiModeratedInterview: 'AI 主持访谈',
  TalkToAva: '与 Ava 对话',
  microphoneAccessTitle: '允许使用麦克风',
  microphoneAccessDescription: 'Ava 需要使用你的麦克风，以便进行自然的语音对话。',
  microphoneAllow: '允许使用麦克风',
  microphoneNotNow: '暂不',
  microphoneConnectedTitle: '麦克风已连接',
  microphoneConnectedDescription: '一切就绪，Ava 已准备好倾听。',
  microphoneDeniedTitle: '需要麦克风权限',
  microphoneDeniedDescription: '请在浏览器设置中允许麦克风访问，然后重试。',
  microphoneTryAgain: '重试',
  VoiceAnswer: '语音应答',
  TextAnswer: '文本应答',
  StudyMainTitle: '在实际面试之前，我们会进行一次筛选',
  StudyMainTip: '很遗憾，您不是此次访谈的目标群体，无法参与此次访谈',
  // ThankYou: '谢谢',
  //
  TitleTop: '快来聊聊吧',
  HeardVoice: '您的声音值得被听见,被鼓励！',
  Sophie: '和Ava来一次简短的访谈吧',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: '开启一段简短的聊天并获得专属',
  Dollars: '于你的CHIMOJI奖励！',
  // Progress: 'the progress of this chat',
  Congrats: '恭喜完成!',
  ThankYou: '感谢您做出的贡献',

  Refresh: '刷新本页不会丢失聊天进度哦',
  Carousel: '由于网络状况，可能会出现轻微延迟',
  CheckOut: '你也想创建这样的采访吗？查看 ',
  Rewarded: '如果你想得到奖励，面试官需要了解你的信息 ',
  InterviewerReward: '这是面试官给你的奖励 ',
  Register: '登录/注册成为',
  Insighteer: 'INSIGHTEER',
  Reward: '以获取专属奖励',
  CreatePassword: '创建密码完成注册',
  Becoming: '成为我们的一份子吧!',
  Password: '请输入您的密码！',
  ChooseTopic: '选择你感兴趣的话题',
  Identity: '你是...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: '关注我们',
  Unique: '这个独一无二专属于你的CHIMOJI将和本次访谈一起被记录在区块链上',
  Next: '下一步',
  ViewRewards: '查看奖励',
  endMeg1: '请在此处留下您的电子邮件，以便我们向您发送语音回放',
  endMeg2: '请在此处留下您的信息，以获取本次采访创建者的奖励',
  endMeg3: '请在此处留下您的信息为本次访谈',
  endMsg5: '请在此处留下您的信息以获取',
  endMsg6: '你的 MBTI 测试结果',
  Done: '提交',
  Done1: '结束',
  GetIncentives: '获取奖励',
  GetStartedFreeNow: '立即免费开始',
  UniqueChimojiNFT: '独特的 Chimoji NFT',
  endMsg4: '想要打造自己的采访?',
  ResumeInterview: '点击继续访谈',
  interviewPausedTitle: '访谈已暂停',
  interviewPausedDescription: '你的访谈进度已保存，准备好后可随时继续。',
  resumeInterviewButton: '恢复访谈',
  pauseInterview: '暂停',
  pauseInterviewConfirmTitle: '暂停访谈？',
  pauseInterviewConfirmContent: '当前进度将被保留，稍后可以继续访谈。',
  pauseInterviewConfirmOk: '暂停',
  pauseInterviewConfirmCancel: '继续访谈',
  poorConnection: '连接不良',
  connectionReconnectingTitle: '正在重新连接…',
  connectionReconnectingDescription: '请保持此页面打开，Ava 正在恢复连接。',
  connectionReconnectedTitle: '已重新连接',
  connectionReconnectedDescription: '网络已恢复，正在继续访谈。',
  connectionDisconnectedTitle: '连接已断开',
  connectionDisconnectedDescription: '你的访谈进度已保存。',
  refresh: '刷新页面不会丢失进度',
  voiceSnapshot: '语音快照',
  fromInterview: '来自人工智能Ava对我的采访',
  findMore: '在chikka.ai上了解更多信息',
  msg1: '与 AVA 交谈，5 分钟内测试您的 MBTI',
  speaking: '你在说话...',
  avaSpeaking: 'AVA 在说话...',
  avaListening: 'AVA 在听...',
  stimuliConversationWithAva: '你正在与 Ava 进行对话',
  stimuliReviewConcepts: '请仔细查看下方概念内容，并回答 Ava 的问题。',
  stimuliSwipeInstruction: '左右滑动以查看全部概念内容。',
  stimuliFullscreenInstruction: '双击图片可全屏查看。',
  finalUploadTitleFallback: '上传文件',
  finalUploadInstructionFallback: '结束访谈前请先上传文件',
  finalUploadTap: '点击上传',
  finalUploadHelp: '你的文件能帮助我们更好地理解你的体验。',
  finalUploadLimit: '最多 10 个文件',
  finalUploadSubmit: '提交',
  finalUploadSkip: '跳过',
  finalUploadWait: '请等待所有文件上传完成',
}
export default zh_CN
